// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"77":"37c59964","297":"c1a7381a","352":"f08a1cbc","582":"6210e89a","787":"fc1ce4eb"}[chunkId] + ".chunk.js";
};